import React, { useEffect, FC } from "react";
import { Table, Button, Tooltip, message } from "antd";
import { YHModal } from "@/components/YHModal";
import { useChargebackDetailsModel } from "./chargebackDetailsModels";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { YhBut } from "@/components/YhButton";
import { formatIntPoint, repairFormatNum, formatNum } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { PlusSquareOutlined } from "@ant-design/icons";
import { IItemDetailList } from "../../../maintenanceType";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";

enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const ItemModal: FC<RouterParamType> = ({ id, mode }) => {
    const { selectedNavId, replaceNav } = useNavModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const {
        itemModel: visible,
        workItemDataSource,
        addDataItemSource,
        setItemModel,
        workItemloadData,
        resetWorkItemloadData,
        setSearchWorkItemData,
        setAddDataItemSource,
        setWorkItemDataSource,
        transformsToPoItemDetailList
    } = useChargebackDetailsModel();
    const onOk = () => {
        transformsToPoItemDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setItemModel(false);
        setAddDataItemSource([]);
        setSearchWorkItemData({})
    };

    useEffect(() => {
        visible && workItemloadData()
    }, [visible])

    const column = (optype: number) => [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '项目编码',
            width: 120,
            dataIndex: 'itemCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '项目名称',
            width: 140,
            dataIndex: 'itemName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '工时',
            width: 100,
            dataIndex: 'workHour',
            editable: true,
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
            // editable: true,
        }, {
            title: '工时费',
            width: 100,
            dataIndex: 'itemAmount',
        },
        {
            title: '原单折扣',
            width: 100,
            dataIndex: 'discountRate',
            render: (text: string) => text + "%"
        },
        {
            title: '原单总计',
            width: 100,
            dataIndex: 'receivableAmount',
        },
        {
            title: '备注',
            width: 120,
            dataIndex: 'note',
            editable: true
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) => optype === OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    txt="添加"
                    click={() => add(record)}
                    disabled={!!addDataItemSource.find(item => item.id === record.id)}
                />
            ) : (
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => remove(record)}
                />
            )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IItemDetailList, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType === OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })

    const roleColumns = (optType: number) => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "orderReturn", "roleCodes": roles };
        return getRoleColumns("orderReturn", "新增项目", newSelectColumns(optType), params);
    };

    const add = async (record: IItemDetailList) => {
        setAddDataItemSource(origin => [...origin, record])
    }
    const remove = async (record: IItemDetailList) => {
        const filterAddDataSource = addDataItemSource.filter(item => item.id !== record.id)
        setAddDataItemSource(filterAddDataSource)
    }
    const notHandleSave = (row: IItemDetailList) => {
        let { workHour, price, oldWorkHour, oldPrice } = row;
        workHour = +formatIntPoint(workHour);
        price = +formatNum(price);
        if (workHour > oldWorkHour) {
            workHour = oldWorkHour as number;
            // message.warning('修改数量时，数量×价格×折扣 不能大于对应配件的明细总计');
            message.warning('修改工时，不能大于原单的工时');
        }
        if (price > oldPrice) {
            price = oldPrice as number;
            // message.warning('修改数量时，数量×价格×折扣 不能大于对应配件的明细总计');
            message.warning('修改工时费时，不能大于原单的工时费');
        }
        let newRow = {
            ...row,
            workHour,
            price,
            itemAmount: +repairFormatNum(workHour * price)
        }
        const index = workItemDataSource.findIndex((item) => row.id === item.id);
        const item = workItemDataSource[index];
        workItemDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkItemDataSource([...workItemDataSource])
    }
    const handleSave = (row: IItemDetailList) => {
        let { workHour, price, oldWorkHour, oldPrice } = row;
        workHour = +formatIntPoint(workHour);
        price = +formatNum(price);
        if (workHour > oldWorkHour) {
            workHour = oldWorkHour as number;
            // message.warning('修改数量时，数量×价格×折扣 不能大于对应配件的明细总计');
            message.warning('修改工时，不能大于原单的工时');
        }
        if (price > oldPrice) {
            price = oldPrice as number;
            // message.warning('修改数量时，数量×价格×折扣 不能大于对应配件的明细总计');
            message.warning('修改工时费时，不能大于原单的工时费');
        }
        let newRow = {
            ...row,
            workHour,
            price,
            itemAmount: +repairFormatNum(workHour * price)
        }
        const index = addDataItemSource.findIndex((item) => row.id === item.id);
        const item = addDataItemSource[index];
        addDataItemSource.splice(index, 1, { ...item, ...newRow });
        setAddDataItemSource([...addDataItemSource])
    }
    const rightChildren = <div className="flex">
        <Button onClick={() => resetWorkItemloadData()} shape="round">重置</Button>
    </div>
    const goItem = () => {
        replaceNav(
            selectedNavId,
            "13-6-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id
                }
            },
            true)
    }
    const title = <>
        <span>待选项目列表</span>
        {/* <PlusSquareOutlined onClick={goItem} style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} /> */}
    </>
    return <YHModal
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        title="工单管理-选择项目"
        width={'70%'}
        bodyHeight={730}
        showFooter={true}
    >
        <YhBox title={title} rightChildren={rightChildren} style={{ marginBottom: "5px" }}>
            <Table
                bordered
                // size="small"
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={roleColumns(OPT_TYPE.ADD) as ColumnsType<IItemDetailList>}
                dataSource={workItemDataSource}
                pagination={false}
                components={components}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title="已选项目列表">
            <Table
                bordered
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={roleColumns(OPT_TYPE.REMOVE) as ColumnsType<IItemDetailList>}
                dataSource={addDataItemSource}
                pagination={false}
                components={components}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}